<template>
  <transition name="slide-fade">
    <div class="page page-your-kits mt-md-5" v-if="user">
      <div class="container">
        <header>
          <div class="row mb-0">
            <div class="col-12 col-md-8">
              <h1>
                <span>Questionnaires</span>
              </h1>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="page-description">
                These questionnaires are a valuable way for you to understand more about yourself and your microbiome. When you fill out the questionnaires, you will receive feedback on your diet, physical activity and mental health status within your Microba Insight™ Report.
              </div>
            </div>
          </div>


          <div id="helpCards" class="row mt-4">
            <div class="col-lg-3 col-12 mb-2">
              <QuestionCard
                question="The value of the questionnaires"
                answer="The questionnaires are a valuable way for you to reflect on your dietary and lifestyle habits and understand more about yourself and your microbiome. When you fill out the questionnaires, you will receive feedback on your diet, physical activity and mental health status within your Microba Insight™ Report and Microbiome Coach call. If you consent to participating in the Future Insights Program, your deidentified answers will also be used as statistics to discover new correlations between microorganisms and health. If you retest in the future or are on a subscription, there will be an option to transfer your responses to additional kits where possible."
                link="Read more"
                image="Value-of-Questionnaire.jpg"
                colour="#0078A9"></QuestionCard>
            </div>
            <div class="col-lg-3 col-12 mb-2">
              <QuestionCard
                question="Do I need to answer everything?"
                answer="To automatically unlock the microbiome coach, 100% completion of all questionnaires is required. However, all questions are optional, and if there are some questions which you would prefer not to answer you do not have to. By completing your questionnaires, you will receive feedback on your responses as part of your microbiome Coach call and it will assist the coach in reviewing your results. To get value out of the microbiome coach session, we require you have completed more than 85% of the questionnaires. If you have completed as much of the questionnaires as you are comfortable with, we are happy to manually book in a microbiome coach session for you when you have also received your microbiome profile results. Please call us on 1300 974 621."
                link="Read more"
                image="Questionnaires-Do-I-need-to-answer-everything.jpg"
                colour="#374A66"></QuestionCard>
            </div>
            <div class="col-lg-3 col-12 mb-2">
              <QuestionCard
                question="When should I complete my questionnaires?"
                answer="The questionnaires encourage you to reflect on health and lifestyle factors that may relate to your sample and a specific time period, from the past day to the past 12 months. Your questionnaires should be completed between taking your sample and when it is received by the lab. You will receive an email once your sample is received to ensure your questionnaires are completed within the next two days to have the results included in your Microba Insight Report. If you complete your questionnaires after this time, please contact us so that your report can be regenerated to have them included in the analysis. If you retest in the future or are on a subscription, there will be an option to transfer your responses to additional kits where possible."
                link="Read more"
                image="Questionnaires-When-should-I-complete.jpg"
                colour="#006470"></QuestionCard>
            </div>
            <div class="col-lg-3 col-12 mb-2">
              <QuestionCard
                question="Contributing to the science"
                answer="Research into the gut microbiome is an exciting new frontier in medicine, revealing important connections about how microorganisms are affecting our health. You have the opportunity to contribute to this important research by consenting to have your data included in the Microba Future Insights Program. <br/><br/>Our Future Insights Program uses the raw data without any identifying details to add to the growing research evidence from around the world. With your permission your microbiome analysis will be matched to the questionnaires about your health and wellbeing, however information will never be linked back to you. The pooled data will be used as statistics to discover new correlations between microorganisms and health as well as how diet and lifestyle affect the populations of microorganisms in the gut. By participating in the program, you can make a meaningful contribution to new discoveries which may help future generations live healthier lives."
                link="Read more"
                image="Questionnaires-Contributing-to-the-science.jpg"
                colour="#665687"></QuestionCard>
            </div>
          </div>



        </header>

        <div class="gray-tabs">
          <b-tabs pills v-model="activeTab">
            <b-tab title="Kits in My Journey" active>

              <ul class="list-group">

                <KitItem v-if="kits" v-for="kit in kits" :kit="kit" :key="kit.id"
                         :showCoach="true"
                         @onClickRedeem="onClickRedeem(kit.id)"
                         @onClickActivate="onClickActivate(kit.id)"
                         @onClickRequest="onClickRequest(kit.id)"
                         @onClickGive="onClickGive(kit.id)"
                         @onClickBook="onClickBook(kit.id)"
                         @onClickReplacement="onClickReplacement(kit.id)"
                         @onClickCoachInfo="showCoachInfoModal = true" />
                <LoadingKitItem v-if="orderProcessing" />
                <NoKits v-if="kits.length < 1" />
              </ul>


              <div id="actionBtnRow" class="row" >
                <div class="col-12 col-md-4 mb-2">
                  <a class="btn-card grey" href="#" @click.prevent="showOrderModal = true">
                    <div>
                      <div class="fa-stack mb-2">
                        <i class="far fa-circle fa-stack-2x"></i>
                        <i class="fa fa-plus fa-stack-1x"></i>
                      </div>
                      Buy a kit for my journey


                    </div>
                  </a>
                </div>
                <div class="col-12 col-md-4 mb-4">
                  <a class="btn-card green" href="#" @click.prevent="openDescription" :class="{ 'btn-card-disabled' : subscriptionActive }">
                    <div>
                      <div class="fa-stack mb-2">
                        <i class="far fa-circle fa-stack-2x"></i>
                        <i class="fa fa-sync-alt fa-stack-1x"></i>
                      </div>
                      Subscribe for regular testing
                    </div>
                  </a>
                </div>


                <div class="col-12 col-md-4 mb-2">
                  <a @click.prevent="openRedeemModal" class="btn-card purple" href="">

                    <div>
                      <div class="fa-stack mb-2">
                        <i class="far fa-circle fa-stack-2x"></i>
                        <i class="fa fa-plus fa-stack-1x"></i>
                      </div>
                      Enter a Voucher Code
                    </div>
                  </a>
                </div>
              </div>

              <!--<ul class="list-group buy-buttons" v-if="user">-->
              <!--<div class="list-group-item">-->
              <!--<div class="row">-->
              <!--<div class="col-12 col-lg-4 mb-3">-->

              <!--<a class="btn btn-primary btn-block" href="#" @click.prevent="showOrderForMe">Buy a kit for My Journey </a>-->
              <!--&lt;!&ndash;<PaymentButton className="btn btn-primary btn-block" :label="addKitText" :giveAway="false" :product="additionalKit" modalHeading="Add to my journey" modalTitle="Confirm shipping & payment" modalCopy="Please confirm your details below" />&ndash;&gt;-->
              <!--</div>-->
              <!--<div class="col-12 col-lg-4 mb-3">-->
              <!--<a class="btn btn-outline-info btn-block" href="#" @click.prevent="showOrderForSomeone">Buy a kit for someone else </a>-->
              <!--</div>-->
              <!--<div class="col-12 col-lg-4 mb-3">-->
              <!--<button class="btn btn-primary btn-block" v-on:click="showRedeemModal = true">Redeem a kit</button>-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->
              <!--</ul>-->

            </b-tab>
            <b-tab title="Kits Given to Others">
              <SentKitItem v-if="kits" v-for="kit in sentKits" :kit="kit" :key="kit.kitId"  @onClickSend="onClickSend(kit.kitId)" />
              <LoadingKitItem v-if="orderProcessing" />
              <NoKits v-if="kits.length < 1" />
            </b-tab>
          </b-tabs>
        </div>

      </div>

      <b-popover :show.sync="showSubscriptionPopover" placement="bottom" target="subButton" >
        <div style="width:190px; text-align:center; color: #00193D; font-size: 14px;	line-height: 22px; padding:12px;">
          You can update or manage
          your subscriptions through
          the ‘My Profile’ page
        </div>
        <div style="text-align:center; width:190px; padding:8px 0 12px 0; font-size: 16px; ">
          <router-link to="profile" style="	color: #339795;">Go to My Profile</router-link>
        </div>
      </b-popover>

      <ModalSendAKit :kitID="selectedKit" :show="showSendModal" @close="showSendModal = false" />
      <!--<ModalActivateAKit :kitID="selectedKit" :show="showActivatModal" @close="showActivatModal = false" />-->
      <ModalActivate :kitID="selectedKit" :slide="activatePage" :show="showActivatModal" @close="showActivatModal = false" />
      <ModalRedeemAKit :kitID="selectedKit" :slide="activatePage" :show="showRedeemModal" :activateModal="showActivatModal" @close="showRedeemModal = false" />
      <ModalBooking :kitID="selectedKit" :show="showBookingModal" @close="showBookingModal = false" />
      <ModalCoachInfo :show="showCoachInfoModal" @close="showCoachInfoModal = false" className='no-padding'/>

      <ModalOrder
        :show="showOrderModal"
        :product="additionalKit"
        :giveAway="showGiveModal"
        :showIntro="false"
        heading=""
        title="Confirm your details"
        copy="Please confirm your details below"
        @close="showOrderModal = false"
      />

      <ModalSubscription
        :show="showSubscriptionModal"
        :product="additionalKit"
        heading=""
        @close="showSubscriptionModal = false"
      />

      <!--<ModalOrder-->
      <!--v-if="showReplacementModal"-->
      <!--:show="showReplacementModal"-->
      <!--:product="replacementKitProduct"-->
      <!--:kitID="selectedKit"-->
      <!--:replacement="true"-->
      <!--:showIntro="false"-->
      <!--heading=""-->
      <!--title="Order Replacement Kit'"-->
      <!--copy="Please confirm your details below"-->
      <!--@close="showReplacementModal = false"-->
      <!--/>-->



      <h1 v-if="orderProcessing">LOADING</h1>
    </div>
  </transition>
</template>

<script>
  import KitItem from '@/components/elements/KitItem'
  import SentKitItem from '@/components/elements/SentKitItem'
  import NoKits from '@/components/elements/noKits'
  import LoadingKitItem from '@/components/elements/LoadingKitItem'
  import { StripeCheckout, Bus } from 'vue-stripe'
  import PurchaseKit from '@/mixins/purchaseKits'
  import ModalActivate from '@/components/models/ModalActivate'
  import ModalSendAKit from '@/components/models/ModalSendAKit'
  import ModalActivateAKit from '@/components/models/ModalActivateAKit'
  import ModalRedeemAKit from '@/components/models/ModalRedeemAKit'
  import ModalBooking from '@/components/models/ModalBooking'
  import ModalOrder from '@/components/models/ModalOrder'
  import ModalSubscription from '@/components/models/ModalSubscription'
  import ModalCoachInfo from '@/components/models/ModalCoachInfo'
  import PaymentButton from '@/components/elements/PaymentButton'
  import QuestionCard from '@/components/elements/QuestionCard'
  import {kitStatuses} from '@/enums/kitItemStatus'
  import _ from 'lodash'

  export default {
    mixins: [ PurchaseKit ],
    components: {
      KitItem,
      SentKitItem,
      NoKits,
      LoadingKitItem,
      ModalSendAKit,
      ModalRedeemAKit,
      ModalActivateAKit,
      ModalBooking,
      PaymentButton,
      ModalCoachInfo,
      ModalOrder,
      ModalActivate,
      Bus,
      ModalSubscription,
      QuestionCard,
      'stripe-checkout': StripeCheckout
    },
    data: () => {
      return {
        activeTab: 0,
        activatePage: '',
        showSubscriptionPopover: false,
        showSendModal: false,
        showActivatModal: false,
        showRedeemModal: false,
        showOrderModal: false,
        showGiveModal: false,
        showBookingModal: false,
        showCoachInfoModal: false,
        showReplacementModal: false,
        showSubscriptionModal: false,
        selectedKit: '',
        replacementKitProduct: {
          amount: Number(process.env.PRICE_REPLACEMENT_KIT) || 30.00,
          label: '1 Microba insight kit',
          orderType: 'REPLACEMENT'
        },
        additionalKit: {
          amount: Number(process.env.PRICE_NEW_KIT) || 419.00,
          label: '1 Microba insight kit',
          orderType: 'NEW'
        },
        selectedProduct: this.tempProduct
      }
    },
    mounted: function () {
      this.$store.dispatch('getUser')
      this.$store.dispatch('getUserKits')
      this.$store.dispatch('getUserSubscription')
      this.$store.dispatch('getSentKits')
    },
    computed: {
      subscriptionActive () {
        let subscriptions = this.$store.state.GET_SUBSCRIPTIONS_RESPONSE || []
        return _.find(subscriptions, (x) => { return x.cancelledDate === null && x.consumerUserId === this.user.id })
      },
      subscriptionText () {
        if (this.subscriptionActive) {
          return 'Subscription active'
        }
        return 'Activate subscription'
      },
      subscriptionClass () {
        if (this.subscriptionActive) {
          return 'active'
        }
        return 'inactive'
      },
      loading: function () {
        return this.$store.state.GET_KITS_PENDING
      },
      kits: function () {
        return this.$store.state.GET_KITS_RESPONSE.filter(kit => kit.kitStatus !== kitStatuses.INVALIDATED) || []
      },
      sentKits: function () {
        return this.$store.state.GET_SENT_KITS_RESPONSE || []
      },
      user: function () {
        return this.$store.state.GET_USER_RESPONSE
      },
      orderProcessing: function () {
        return false // this.$store.state.processing.order
      },
      addKitText: function () {
        return 'Buy a kit for my journey'
      },
      selectedKitId () {
        return this.selectedKit.kitId
      }
    },

    methods: {
      openDescription () {
        if (!this.subscriptionActive) {
          this.showSubscriptionModal = true
        }
      },
      toggleSubscription () {
        if (this.subscriptionActive) {
          this.showSubscriptionPopover = !this.showSubscriptionPopover
        } else {
          this.showSubscriptionModal = true
        }
        // this.subscriptionActive = !this.subscriptionActive
      },
      showOrderForMe () {
        this.showGiveModal = false
        this.showOrderModal = true
      },
      showOrderForSomeone () {
        this.showGiveModal = true
        this.showOrderModal = true
      },
      onClickRedeem: function (kitID) {
        this.selectedKit = kitID
        this.showRedeemModal = true
      },
      onClickSend: function (kitID) {
        this.selectedKit = kitID
        this.showActivatModal = true
      },
      onClickGive: function (kitID) {
        this.selectedKit = kitID
        this.showSendModal = true
      },
      openRedeemModal () {
        this.activatePage = 'REDEEM_CODE_WITH_ADDRESS'
        this.showRedeemModal = true
      },
      onClickRequest: function (kitID) {
        this.selectedKit = kitID
        this.activatePage = 'REDEEM_CODE_WITH_ADDRESS'
        this.showActivatModal = true
      },
      onClickActivate: function (kitID) {
        this.selectedKit = kitID
        this.showActivatModal = true
      },
      onClickBook: function (kitID) {
        this.selectedKit = kitID
        this.showBookingModal = true
      },
      onClickReplacement: function (kitID) {
        this.selectedKit = kitID
        this.showReplacementModal = true
      },
      showPurchaseModal: function (product) {
        this.selectedProduct = product
        this.showOrderModal = true
      }
    },

    name: 'yourKits'
  }
</script>

<style scoped lang="scss">

  .toggle{
    text-align: center;
    font-size: 19px;
    line-height: 36px;
    color: #8d8f9c;
  }

  .toggleSubItem{
    display:block;
    font-size:16px;
    margin-top:10px;
    margin-bottom:20px;
    color: #339795;
  }

  .toggleSwitch{
    float:right;
    width:220px;
    height:45px;
    border-radius: 25px;
    cursor:pointer;
    position:relative;;

    display: flex;
    flex-direction: row;
    align-items: center;

    .toggle{
      height: 35px;
      width: 35px;
      border-radius: 50%;
      background-color:#fff;
    }

    &.inactive{
      background: #cfd1dd;

      .toggle{
        position:absolute;
        left: 8px;
      }

      span{
        text-align: right;
        padding-right:20px;
      }
    }

    &.active{
      background: #339795;

      .toggle{
        position:absolute;
        right: 8px;
      }

      span{
        text-align: left;
        padding-left:20px;
      }


    }

    span{
      color: #fff;
      width: 100%;
      font-size:16px;
      font-weight: 400
    }
  }

  @media (min-width:992px) {
    #actionBtnRow {
      padding-left: 100px;
      padding-right: 100px;
    }
  }

  .list-group{
    margin-bottom: 2rem;
  }
  .list-group-item{
    padding-bottom: 0.5rem;
  }

  .page-description {
    color: #00193D;
    font-size:1rem;
  }
  .buy-buttons .list-group-item{
    background: #EEF0F2;
  }
  .buy-buttons .list-group-item .row{
    max-width: 860px;
    margin: 0px auto;
  }


</style>



// WEBPACK FOOTER //
// src/application/customer/Surveys.vue